module.exports = __webpack_public_path__ + "img/footer_QRCode_01.a559a496.png";